<p-table [value]="vehicles" [lazy]="true" (onLazyLoad)="loadData($event)"
  [rows]='vehicles.length' [totalRecords]='vehicles'
  [rowsPerPageOptions]="[10,20,30,40,50]" [paginator]="true" [loading]="loading" [rowHover]="true"
    [showCurrentPageReport]="true" currentPageReportTemplate="
      {{ 'table.showing' | translate }} {first}
      {{ 'table.to' | translate }} {last}
      {{ 'table.of' | translate }} {totalRecords}
      {{ 'table.entries' | translate}}" class="custom-table" styleClass="p-datatable-striped"
  [globalFilterFields]="['name','brand.name','model.name','version.name','type.name','frameNumber','status.name','billingAccount.name']">

  <!-- #region TABLE TITLE DEFINITION -->
  <ng-template pTemplate="caption">
    <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
      {{ 'tableManagement.vehicle.vehiclesManagement' | translate }}
    </div>
  </ng-template>
  <!-- #endregion -->

  <!-- #region TABLE COLUMN DEFINITION -->
  <ng-template pTemplate="header">
    <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">

      <!-- CAR LICENSE PLATE -->
      <th pSortableColumn="name">
        <div class='d-flex align-items-center h-100'>
          <!-- COLUMN TITLE -->
          <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
            {{ 'control-panel.vehicles.licensePlate' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN SORT && FILTER ICONS -->
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="name"></p-sortIcon>
              <p-columnFilter field="name" type="text" matchMode="contains"
                placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
                [showOperator]="false" [showAddButton]="false">
              </p-columnFilter>
            </div>
          </div>
        </div>
      </th>

      <!-- BRAND -->
      <th pSortableColumn="brand">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.brands.brand' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN SORT && FILTER ICONS -->
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="brand"></p-sortIcon>
              <p-columnFilter field="brand" matchMode="in" display="menu" [showMatchModes]="false"
                [showOperator]="false" [showAddButton]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect [ngModel]="value" [options]="brandList" i18n-placeholder placeholder="{{'general.filters.any' | translate}}"
                    (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                    <ng-template let-option pTemplate="item">
                      <div class="p-multiselect-brand-option">
                        @if (option?.logo?.imageEncoded) {
                          <img id='uploadedImage' alt=''
                            [src]="option.logo.imageEncoded"
                            [style]="{'vertical-align':'middle', 'max-height':'32px', 'width':'32px', 'margin-right':'10px'}">
                        }
                        @if (!option?.logo?.imageEncoded) {
                          <img id='uploadedImage' alt=''
                            [src]="assets/icons/no-image-available.svg"
                            [style]="{'vertical-align':'middle', 'max-height':'32px', 'width':'32px', 'margin-right':'10px'}">
                        }
                        <span class="ml-1">{{option.name}}</span>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </div>
          </div>

        </div>
      </th>

      <!-- MODEL -->
      <th pSortableColumn="model">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.models.model' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN SORT && FILTER ICONS -->
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="model"></p-sortIcon>
              <p-columnFilter field="model" matchMode="in" display="menu" [showMatchModes]="false"
                [showOperator]="false" [showAddButton]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect [ngModel]="value" [options]="modelList" i18n-placeholder placeholder="{{'general.filters.any' | translate}}"
                    (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                    <ng-template let-option pTemplate="item">
                      <div class="p-multiselect-model-option">
                        <span class="ml-1">{{option.name}}</span>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </div>
          </div>

        </div>
      </th>

      <!-- ACTIVE -->
      <th pSortableColumn="enabled">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'general.active' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="enabled"></p-sortIcon>
            <p-columnFilter field="enabled" type="boolean" display="menu"
            [showApplyButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>

    </tr>
  </ng-template>
  <!-- #endregion  -->

  <ng-template pTemplate="body" let-vehicle>
    <tr class='p-selectable-row custom-rows' [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
      <td>{{vehicle.name}}</td>
      <td>{{vehicle.model.brand === null ? '' : vehicle.model.brand.name}}</td>
      <td>{{vehicle.model === null ? '' : vehicle.model.name}}</td>
      <td>
        <div class="d-flex justify-content-center align-items-center">
          <i class="pi"
          [ngClass]="{'true-icon pi-check-circle': vehicle.enabled, 'false-icon pi-times-circle': !vehicle.enabled}"></i>
        </div>
      </td>
    </tr>
  </ng-template>

  <!-- <ng-template ngFor let-vehicle [ngForOf]="vehicles" let-i="index">
  <tr class='p-selectable-row custom-rows' [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)='editVehicle(vehicle)'>
    <td>{{vehicle.name}}</td>
  </tr>
</ng-template> -->

<ng-template #na>
  <td>N/A</td>
</ng-template>

<!------ TABLE EMPTY MESSAGE ---------------------------------------------------------------->
<ng-template pTemplate="emptymessage">
  <tr>
    <td colspan="11" class="p-0">
      <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
                    {{ 'table.tableEmptyMessage' | translate }}!
                </div>
    </td>
  </tr>
</ng-template>

<!------ FOOTER ----------------------------------------------------------------------------->
<ng-template pTemplate="footer">
  <tr>
    <td colspan="4" class="p-0">
      <div class="d-flex flex-row align-items-center p-3 gap-3">
        <!-- ADD RACING EVENT BUTTON -->
        <app-table-add-button [text]=" 'tableManagement.vehicle.vehicle' | translate "
        (btnClick)="createVehicle()"></app-table-add-button>

        <!-- EXCEL BUTTON -->
        <app-table-excel-button class="buttonTableExcel"
        (btnClick)="exportExcel()"></app-table-excel-button>
      </div>
    </td>
  </tr>
</ng-template>
</p-table>